// extracted by mini-css-extract-plugin
export default {"CurrentStepContainer":"Dashboard_CurrentStepContainer__6AQl4","MedicationPharmacyInfo":"Dashboard_MedicationPharmacyInfo__AEENa"};